module.exports = __webpack_public_path__ + "static/media/whurth-min.7ad3b40a.png";